import { render } from "./ReceivingAddressPick.vue?vue&type=template&id=3ff4d596&scoped=true"
import script from "./ReceivingAddressPick.vue?vue&type=script&lang=js"
export * from "./ReceivingAddressPick.vue?vue&type=script&lang=js"

import "./ReceivingAddressPick.vue?vue&type=style&index=0&id=3ff4d596&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff4d596"]])

export default __exports__